import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Flex, Heading, IconButton, SxProps, Text } from '@modusign/design-system';

export interface ResourceModalHeaderProps extends SxProps {
  title: React.ReactNode;
  icon?: React.ReactNode;
  resourceName?: React.ReactNode;
  onClose?: () => void;
}

function ResourceModalHeader({ title, icon, resourceName, onClose }: ResourceModalHeaderProps) {
  return (
    <Flex
      borderBottom="1px solid"
      borderBottomColor="modalBorderNeutralBase"
      flexDirection="column"
      gap={2}
      p={6}
      pt="20px"
      width="100%"
    >
      <Flex alignItems="center" gap={2} justifyContent="space-around">
        {icon}
        <Heading as="h1" flex="auto" fontSize="lg" fontWeight="medium">
          {title}
        </Heading>
        {onClose && (
          // TODO: 디자인시스템 CloseButton 사용 패턴에 맞게 최신화하기
          <IconButton
            aria-label="닫기 버튼"
            color="textNeutralLight"
            sx={{
              borderRadius: '3px',
              width: '30px',
              height: '30px',
              '&:hover': {
                bg: 'buttonBackgroundNeutralSlightlyDark',
                '& > svg': {
                  color: 'textNeutralDark',
                },
              },
            }}
            onClick={onClose}
          >
            <Box as={FontAwesomeIcon} height="18px" icon={faXmark} width="12px" />
          </IconButton>
        )}
      </Flex>
      {resourceName && <Text fontSize="sm">{resourceName}</Text>}
    </Flex>
  );
}

export default ResourceModalHeader;
